import { render } from "./TopProducts.vue?vue&type=template&id=c6eb4a84"
import script from "./TopProducts.vue?vue&type=script&lang=js"
export * from "./TopProducts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__